import { Paper, Stack } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useSamplingQueries } from '../data-access/queries/sampling';

import { Timeline } from './timeline/timeline';

import { useFiltersStore, usePagination } from '@data-access';

export function OrdersTimeline() {
  const page = useFiltersStore.use['orders']().pagination.pageIndex + 1;
  const sorting = useFiltersStore.use['orders']().sorting;
  const filters = useFiltersStore.use['orders']().filters;
  const [, setPage] = usePagination('orders');

  const samplingQueries = useSamplingQueries();
  const { data } = useQuery(
    samplingQueries.orders.list({
      page,
      sorting,
      filters,
    }),
  );

  const { earliestDate, latestDate } = useMemo(() => {
    if (data?.results && data.results.length > 0) {
      const allDates = data.results.flatMap((order) =>
        order.analysis_commands.flatMap((command) =>
          command.timelines.flatMap((timeline) => [
            new Date(timeline.start_date),
            new Date(timeline.end_date),
          ]),
        ),
      );
      const earliest = new Date(
        Math.min(...allDates.map((date) => date.getTime())),
      );
      const latest = new Date(
        Math.max(...allDates.map((date) => date.getTime())),
      );
      return { earliestDate: earliest, latestDate: latest };
    } else {
      const now = new Date();
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const endOfMonth = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        0,
        23,
        59,
        59,
        999,
      );
      return { earliestDate: startOfMonth, latestDate: endOfMonth };
    }
  }, [data]);

  return (
    <Paper h="100%" p={0}>
      <Stack gap="md" h="100%">
        <Timeline
          earliestDate={earliestDate}
          latestDate={latestDate}
          onPageChange={(p) => setPage({ pageIndex: p - 1, pageSize: 25 })}
          orders={data?.results || []}
          page={page}
          pages={data?.count ? Math.ceil(data.count / 25) : 1}
        />
      </Stack>
    </Paper>
  );
}
